module.exports = __webpack_public_path__ + "images/category_lp/earphone/new/assessment_achievements/3@2x_dd39f33d77ced0176afa12e7ff017bb0.png";